export default "__VITE_ASSET__CmXgutpe__"